// CONSTANTS
import { ROUTE_WP_PAGE } from '@/constants/routes';

// UTILITY
import getLink from '@/utility/routes';

export default data => {
  const url = data?.slug ? getLink(ROUTE_WP_PAGE, { slug: data.slug }) : '';
  const descriptionItem = data?.yoast_meta?.find(item => item.property === 'og:description');

  const questions = [
    {
      title: 'What is cord cutting?',
      answer:
        "As you may have heard, no longer is your cable/satellite company the only way to get great TV shows or movies. As Smart TVs and Netflix have exploded in popularity, more and more content is now available outside of the traditional cable/satellite bundle. All you need is an internet connection and a streaming device to get the Live TV channels you love, reruns On-Demand, and even brand new content from new streaming services you've never heard of! Additionally, a Digital Antenna can be used to pick up Broadcast Networks such as ABC, CBS, NBC, and FOX for free.",
    },
    {
      title: 'What does MyBundle do?',
      answer:
        "Our suite of free tools help you eliminate all the work needed to find the streaming services that have the content you actually want. Whether it's finding a cheaper Live TV streaming replacement with the channels you need, discovering new streaming services that match your interests, or deciding what to watch next–we're here to help. (And help you save hundreds of dollars and hours in the process!)",
    },
    {
      title: 'What is the Find My Bundle tool?',
      answer:
        'Built for people who are ready to drop their big cable TV bills and save money. Based on your preferences and favorite channels, our Find My Bundle tool will figure out which Live TV streaming package is best for you, making the transition to streaming TV as seamless as can be. Get all the live TV channels and content you love without all the expensive and hidden fees of cable.',
    },
    {
      title: 'What is the Streaming Marketplace?',
      answer:
        "Our Streaming Marketplace offers you a place to discover and learn about new streaming services, whether you decide to keep your cable TV or never had it in the first place. While most people know about Netflix, Hulu, Prime Video, and Disney+, there are hundreds of other streaming services! Our Streaming Marketplace helps you find and sign-up for unique and niche services that match your interests. Also, if you're looking for a particular show or movie, search our Streaming Marketplace to find on which service it can be streamed.",
    },
  ];

  return {
    '@type': 'FAQPage',
    name: 'FAQ',
    description: descriptionItem?.content || '',
    inLanguage: 'English',
    url,
    mainEntity: questions.map(question => ({
      '@type': 'Question',
      name: question.title,
      acceptedAnswer: {
        '@type': 'Answer',
        text: `<p>${question.answer}</p>`,
      },
    })),
  };
};
